export default __webpack_public_path__ + "static/media/dunkin.921690ae.png";